/* eslint-disable arrow-parens */
import Styled, { css } from 'styled-components';
import { ChoiceBorder, ChoiceImage } from '@gcc/pip-components/dist/ChoiceBox/styles';
import {
  BoxChoice,
  CheckWrapper,
  CheckText,
  ControlWrapper,
  DescriptionLabel,
} from '@gcc/pip-components/dist/ChoiceBoxWithControl/styles';
import ChoiceBoxSection from '@gcc/pip-components/dist/ChoiceBoxSection';
import { ViewAll } from '@gcc/pip-components/dist/collapsibles';

export const ViewAllRight = Styled(ViewAll)`
  float: right;
  padding-right: 50px
`;

export const ChoiceWrapper = Styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  ${(props) => props.selected && css`
    font-weight: bold;
  `}
`;

export const FixedSizeChoiceImageWrapper = Styled.div`
  font-size: 1.4rem;
  margin: 0;
  padding: 0;

  ${CheckText} {
    font-size: 1.3rem;
    padding: 4px 0;
    width: auto;
  }

  ${CheckWrapper} {
    margin: 0;
    padding: 0;
    width: auto;
  }

  ${ChoiceBoxSection} {
    cursor: pointer;
    @media (max-width: 767px) {
      margin-bottom: 1rem;
      display: flex;
      width: 100%;
      max-width: calc(100vw - 45px);
      flex-wrap: wrap;
      overflow: visible;
    }
  }

  ${ChoiceImage} {
    img {
      margin: 0;
      padding: 0;
      width: 124px;
    }
    margin: 0;
    padding: 0;
  }

  ${ControlWrapper} {
    padding: 0;
    @media (max-width: 767px) {
      display: none;
    }
  }

  ${ChoiceBorder} {
    box-sizing: border-box;
    background: #fff;
    border-radius: 3px;
    padding: 4px;
    margin: 10px 10px 0 0;
    min-width: 135px;
  }

  ${BoxChoice} {
    margin: 0;
    padding: 0;
  }

  ${DescriptionLabel} {
    text-align: left;
    font-size: 1.2rem;
    font-weight: bold;
    margin: 4px 0;
    width: auto;
  }
`;

export const Description = Styled.p`
  margin-bottom: 8px;
  max-width: 570px;
`;
